<!--
	@name app-layout
	@description Front page layout
	@date 2020/02/21
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div>
		<div>
			<!-- header -->
			<!-- <layout-header /> -->

			<!-- sidebar -->
			<!-- <layout-sidebar ref="sidebar" /> -->

			<!-- content -->
			<v-main>
				<!-- breadcrumb -->
				<!-- <layout-breadcrumb /> -->

				<div class="pt-12">
					<router-view />
				</div>
			</v-main>
			<!-- footer -->
			<!-- <layout-footer ref="footer" /> -->
		</div>
	</div>
</template>

<script>
	// import LayoutHeader from './header';
	// import LayoutFooter from './footer';
	// import LayoutBreadcrumb from './breadcrumb';

	export default {
		components: {
			// LayoutHeader,
			// LayoutFooter,
			// LayoutBreadcrumb
		},

		computed: {
			isBlank() {
				return this.$route.meta?.layout === 'blank';
			}
		},

		created() {}
	};
</script>
